import { React, useState, useEffect } from "react";
import styled from "styled-components";
import { Layout, Table, Button, PageHeader } from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
} from "../../styledElements";
import logoCompany from "../../../Assets/Images/logo.svg";
import Iconmoon from "../../../Components/IconsFiles/icon";
import * as htmlToImage from "html-to-image";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { getCompanyDetails } from "../../../Services/companyServices";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";

const PrintData = styled.div`
  padding: 0px;
  margin: 40px auto;
  background-color: #fff;
  width: 845px;
`;

const ExportHeader = styled.div`
  background-color: #faf9f8;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 25%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;

const ExportTable = styled.div`
  table {
    width: 100%;
  }
  thead th {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  td {
    border-bottom: 1px solid #000;
  }

  th,
  td {
    text-align: left;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 90px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
`;

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}

addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const ExportJumboReelsPdf = (props) => {
  const [showLoader, setLoader] = useState(false);
  const [company, setCompany] = useState();
  const navigate = useNavigate();
  // const timeElapsed = Date.now();
  // const today = new Date(timeElapsed);
  const currentDate = new Date();
  const today = (currentDate.getDate() + " " + currentDate.toLocaleString("default", { month: "long" }) + "," +  currentDate.getFullYear());
  const location = useLocation();
  const [data, setData] = useState(location.state?.pdfData);
  const [pageKey, setPageKey] = useState(location.state?.pageKey);
  const [fileNameForPDF, setFileNameForPDF] = useState(location.state?.fileNameForPDF);
  useEffect(() => {
    setCompanyDetails();
  }, []);

  const setCompanyDetails = () => {
    getCompanyDetails()
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => console.log("Error", error));
  };

  const exportHandler = () => {
    const input = document.getElementById("export-content");
    html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
      (canvas) => {
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];
        const filename = "myfile.pdf";

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5, 11]);

        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save(fileNameForPDF+".pdf");
      }
    );
  };
  return (
      <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
      {pageKey == "Jumbo Reels Records" && (
        <PageHeader
          ghost={false}
          onBack={() => navigate("../jumbo-reel-records/export", {state: 
            {
              jumboRecords: data,
              pageKey: pageKey,
              returnKey: true,
              searchKey: location.state?.searchKey,
              fileName: fileNameForPDF,
          },
        })}
          title="Jumbo Reel Records Preview"
          extra={[ 
            <Button
              key="1"
              className="themeBtn"
              onClick={() => exportHandler()}
            >
            <Iconmoon icon="download" size={17} color="#FFFFFF" />
            Download Jumbo Reel Records
            </Button>
          ]}
        ></PageHeader>
      )}
      {pageKey == "Mapping Details" && (
        <PageHeader
          ghost={false}
          onBack={() => navigate("../jumbo-reel-records/export", {state: 
            {
              jumboRecords: data,
              pageKey: pageKey,
              returnKey: true,
          },
        })}
          title="Jumbo Roll Mapping Records Preview"
          extra={[ 
            <Button
              key="1"
              className="themeBtn"
              onClick={() => exportHandler()}
            >
            <Iconmoon icon="wrong" size={14} color="#FFFFFF" />
            Download Jumbo Roll Mapping Records
            </Button>
          ]}
        ></PageHeader>
      )}
      </PageTitleComp>
      {/* <Button onClick={() => exportHandler()} className="themeBtn">Download Machine Records </Button> */}
      <PrintData id="export-content">
        <OtherPages>
          <Layout
            style={{
              backgroundColor: "#ffffff",
            }}
          >
            <div>
              <ExportHeader>
                <div className="file-header">
                  <div className="file-header-logo">
                    <img src={logoCompany} alt="Kaiznn" />
                  </div>
                  <div className="client-name">
                    {company && <h4>{company.business_name} </h4>}
                    {pageKey == "Jumbo Reels Records" && (<h6>Jumbo Records</h6>)}
                    {pageKey == "Mapping Details" && (<h6>Jumbo Roll Mapping Records</h6>)}
                    <div className="client-data">
                      <div>
                        <label>Number of records</label>
                        <span>{data.length}</span>
                      </div>
                      <div>
                        <label>Date:</label>
                        <span>{today}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ExportHeader>
              {pageKey == "Jumbo Reels Records" && (<ExportTable>
                <table>
                  <thead>
                    <tr >
                      <th>JUMBO REEL DETAILS</th>
                      <th>CREATED DATE</th>
                      <th>PRODUCT SPECIFICATION</th>
                      <th>MACHINE CODE</th>
                      <th>WIDTH</th>
                      <th>WEIGHT</th>
                      <th>PRODUCTION SHIFT</th>
                      <th>PRODUCTION DATE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((reel) => {
                      return (
                        <tr>
                          <td>
                            <p className="p-ton f-10">{`No.: ${reel.number}`}</p>
                            <p className="reel f-10">{reel.status}</p>
                            <p className="reel f-10">{`${reel.utilized}`}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{reel.created_date}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{reel.product_spec}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{reel.machineCode}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{`${reel.width}`}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{`${reel.weight}`}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{`${reel.shift}`}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{`${reel.production_date}`}</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </ExportTable>)}
              {pageKey == "Mapping Details" && (<ExportTable>
                <table>
                <thead>
                <tr >
                      
                      <th>PARENT REEL/SET NUMBER</th>
                      <th>JOB CARD NUMBER</th>
                      <th>FINISHING DATE</th>
                      <th>SIZE</th>
                      <th>CORE OD</th>
                      <th>REEL OD</th>
                      <th>WEIGHT</th>
                      <th>NUMBER OF REELS/SHEETS</th>
                      <th>MATCH TRIM</th>
                      <th>NET TRIM</th>
                </tr>
                </thead>
                <tbody>
                {data.map((reel) => {
                  return (
                    <tr>
                       <td>
                          <p className="p-ton f-10">{`No.: ${reel.parentReelNo}`}</p>
                          <p className="reel f-10">{`Status: ${reel.parentReelStatus}`}</p>
                       </td>
                       <td>
                          <p className="p-ton f-10">{`No.: ${reel.jc_code}`}</p>
                          <p className="reel f-10">{reel.jobCardState}</p>
                       </td>
                       <td>
                          <p className="p-ton f-10">{reel.rewinding_date}</p>
                       </td>
                       <td>
                          <p className="p-ton f-10">{`${reel.size}`}</p>
                       </td>
                       <td>
                          <p className="p-ton f-10">{`${reel.coreOD}`}</p>
                       </td>
                       <td>
                          <p className="p-ton f-10">{`${reel.reelOD}`}</p>
                       </td>
                       <td>
                          <p className="p-ton f-10">{`${reel.weight}`}</p>
                       </td>
                       <td>
                          <p className="p-ton f-10">{reel.noOfChildReels}</p>
                       </td>                       
                       <td>
                          <p className="p-ton f-10">{`${reel.matchTrim}`}</p>
                       </td>
                       <td>
                          <p className="p-ton f-10">{`${reel.netTrim}`}</p>
                       </td>
                    </tr>
                      );
                  })}
                </tbody>
                </table>
              </ExportTable>)}
            </div>
          </Layout>
        </OtherPages>
      </PrintData>
    </RightLayoutContainer>
);
};
export default ExportJumboReelsPdf;
